// Mock data for the Bora Moyo front-end template. No backend — purely for UI.

export const VIBE_TAGS = [
  "Adventurer",
  "Intellectual",
  "Romantic",
  "Wildcard",
  "Creative",
  "Nomad",
  "Founder",
  "Aesthete",
  "Quiet Storm",
  "Thinker",
  "Dreamer",
  "Protector",
];

export const prospects = [
  {
    id: "p1",
    name: "Elena",
    age: 28,
    birth_month: "3",
    birth_day: "15",
    location: "Brooklyn, NY",
    city: "Brooklyn",
    occupation: "Architect",
    video: null,
  image:
      "https://images.unsplash.com/photo-1769650795569-e51a6e9580c3?q=85&w=900",
    videoPoster:
      "https://images.unsplash.com/photo-1769650795569-e51a6e9580c3?q=85&w=1200",
    hasVideo: true,
    tags: ["Aesthete", "Intellectual", "Romantic"],
    headline: "Designs cathedrals of light for a living.",
    bio: "Architect by day, jazz vinyl collector by night. Values slowness, texture, and long conversations.",
    compatibility: 94,
    scores: {
      values: 96,
      communication: 91,
      lifestyle: 88,
      chemistry: 93,
      futureGoals: 95,
      effort: 90,
    },
    prompts: [
      {
        q: "A perfect Sunday looks like…",
        a: "Coffee at dawn, a half-written letter, a long walk that turns into dinner.",
      },
      {
        q: "The last thing I learned by heart…",
        a: "A small passage of Rilke — in the original German.",
      },
    ],
    interests: ["Architecture", "Jazz", "Film", "Pottery", "Travel"],
    greenFlags: ["Deep listener", "Low ego", "Shows up"],
    cautions: ["Very independent schedule"],
  },
  {
    id: "p2",
    name: "Marcus",
    age: 31,
    birth_month: "7",
    birth_day: "4",
    location: "Austin, TX",
    city: "Austin",
    occupation: "Founder, climate tech",
    video: null,
  image:
      "https://images.unsplash.com/photo-1670687811377-8b39b8644d1a?q=85&w=900",
    videoPoster:
      "https://images.unsplash.com/photo-1670687811377-8b39b8644d1a?q=85&w=1200",
    hasVideo: true,
    tags: ["Founder", "Adventurer", "Thinker"],
    headline: "Builds companies. Reads poetry on planes.",
    bio: "Climate-tech founder. Ultrarunner. Believes relationships are the only compound interest that matters.",
    compatibility: 91,
    scores: {
      values: 92,
      communication: 89,
      lifestyle: 85,
      chemistry: 90,
      futureGoals: 94,
      effort: 96,
    },
    prompts: [
      {
        q: "The thing I'm most afraid to want…",
        a: "A quiet life, after all the building is done.",
      },
      {
        q: "You'll know me when…",
        a: "I stop answering emails at dinner.",
      },
    ],
    interests: ["Ultrarunning", "Climate", "Poetry", "Mezcal", "Stargazing"],
    greenFlags: ["Ambitious with warmth", "Honest", "Communicative"],
    cautions: ["Travels often"],
  },
  {
    id: "p3",
    name: "Noor",
    age: 27,
    location: "London, UK",
    city: "London",
    occupation: "Film composer",
    video: null,
  image:
      "https://images.pexels.com/photos/13422041/pexels-photo-13422041.jpeg?w=900",
    videoPoster:
      "https://images.pexels.com/photos/13422041/pexels-photo-13422041.jpeg?w=1200",
    hasVideo: true,
    tags: ["Creative", "Dreamer", "Quiet Storm"],
    headline: "Scores the kind of films you watch alone.",
    bio: "Film composer with a stubborn belief that the right chord can unlock a person.",
    compatibility: 89,
    scores: {
      values: 90,
      communication: 93,
      lifestyle: 82,
      chemistry: 95,
      futureGoals: 80,
      effort: 86,
    },
    prompts: [
      {
        q: "What you'd catch me rewatching…",
        a: "In the Mood for Love. Every autumn. Without fail.",
      },
      {
        q: "A love language people underrate…",
        a: "Making someone a playlist that only makes sense to you two.",
      },
    ],
    interests: ["Composition", "Cinema", "Tea", "Rain walks", "Handwritten letters"],
    greenFlags: ["Emotionally fluent", "Curious", "Patient"],
    cautions: ["Long studio hours"],
  },
  {
    id: "p4",
    name: "Theo",
    age: 30,
    location: "Lisbon, PT",
    city: "Lisbon",
    occupation: "Marine biologist",
    video: null,
  image:
      "https://images.pexels.com/photos/29433729/pexels-photo-29433729.png?w=900",
    videoPoster:
      "https://images.pexels.com/photos/29433729/pexels-photo-29433729.png?w=1200",
    hasVideo: false,
    tags: ["Adventurer", "Protector", "Thinker"],
    headline: "Spends more time underwater than on land.",
    bio: "Marine biologist. Mostly salt, part boat, part man. Looking for something that stays still.",
    compatibility: 86,
    scores: {
      values: 88,
      communication: 80,
      lifestyle: 78,
      chemistry: 86,
      futureGoals: 84,
      effort: 90,
    },
    prompts: [
      { q: "Dangerous hobby…", a: "Falling asleep before replying." },
      { q: "A better world has…", a: "Fewer nets, more silence, more coral." },
    ],
    interests: ["Diving", "Ocean policy", "Sailing", "Cooking", "Espresso"],
    greenFlags: ["Steady", "Mission-driven"],
    cautions: ["Often at sea for weeks"],
  },
  {
    id: "p5",
    name: "Ava",
    age: 29,
    location: "Paris, FR",
    city: "Paris",
    occupation: "Curator, modern art",
    video: null,
  image:
      "https://images.pexels.com/photos/31642714/pexels-photo-31642714.jpeg?w=900",
    videoPoster:
      "https://images.pexels.com/photos/31642714/pexels-photo-31642714.jpeg?w=1200",
    hasVideo: true,
    tags: ["Aesthete", "Intellectual", "Wildcard"],
    headline: "Curates museums. Collects strangers' secrets.",
    bio: "I believe in slow dinners, strong espresso, and the exact right sentence.",
    compatibility: 92,
    scores: {
      values: 91,
      communication: 94,
      lifestyle: 89,
      chemistry: 92,
      futureGoals: 88,
      effort: 89,
    },
    prompts: [
      { q: "My small rebellion…", a: "Reading in bars. Alone. On a Saturday." },
      { q: "I'm working on…", a: "Saying the harder, truer thing first." },
    ],
    interests: ["Contemporary art", "Natural wine", "French cinema", "Swimming"],
    greenFlags: ["Witty", "Self-aware"],
    cautions: ["Splits time between two cities"],
  },
  {
    id: "p6",
    name: "Kai",
    age: 32,
    location: "Tokyo, JP",
    city: "Tokyo",
    occupation: "Product designer",
    video: null,
  image:
      "https://images.pexels.com/photos/36632592/pexels-photo-36632592.png?w=900",
    videoPoster:
      "https://images.pexels.com/photos/36632592/pexels-photo-36632592.png?w=1200",
    hasVideo: true,
    tags: ["Creative", "Nomad", "Thinker"],
    headline: "Designs quiet products for loud lives.",
    bio: "Product designer. Runs a small ceramics studio on weekends. Low key, high effort.",
    compatibility: 88,
    scores: {
      values: 89,
      communication: 86,
      lifestyle: 93,
      chemistry: 84,
      futureGoals: 87,
      effort: 92,
    },
    prompts: [
      { q: "Underrated skill…", a: "Knowing when not to send the text." },
      { q: "Proud of…", a: "Answering tough conversations in person." },
    ],
    interests: ["Design", "Ceramics", "Matcha", "Basketball", "Bookshops"],
    greenFlags: ["Grounded", "Kind", "Reliable"],
    cautions: ["Reserved at first"],
  },
  {
    id: "p7",
    name: "Isla",
    age: 26,
    location: "Copenhagen, DK",
    city: "Copenhagen",
    occupation: "Neuroscientist",
    video: null,
  image:
      "https://images.unsplash.com/photo-1775829102423-16393e34857b?q=85&w=900",
    videoPoster:
      "https://images.unsplash.com/photo-1775829102423-16393e34857b?q=85&w=1200",
    hasVideo: false,
    tags: ["Intellectual", "Quiet Storm", "Dreamer"],
    headline: "Studies the brain. Still believes in magic.",
    bio: "PhD by training, romantic by nature. Looking for someone who takes ideas — and people — seriously.",
    compatibility: 90,
    scores: {
      values: 93,
      communication: 92,
      lifestyle: 86,
      chemistry: 88,
      futureGoals: 91,
      effort: 88,
    },
    prompts: [
      { q: "I light up when…", a: "Someone asks a question I've never been asked." },
      { q: "A personal non-negotiable…", a: "Curiosity. About the world. About me." },
    ],
    interests: ["Neuroscience", "Skiing", "Dinners", "Chess", "Kintsugi"],
    greenFlags: ["Direct", "Warm", "Curious"],
    cautions: ["Focused during deadlines"],
  },
  {
    id: "p8",
    name: "Julian",
    age: 33,
    location: "Mexico City, MX",
    city: "Mexico City",
    occupation: "Chef, tasting menu",
    video: null,
  image:
      "https://images.unsplash.com/photo-1770896687186-895de50a4123?q=85&w=900",
    videoPoster:
      "https://images.unsplash.com/photo-1770896687186-895de50a4123?q=85&w=1200",
    hasVideo: true,
    tags: ["Romantic", "Creative", "Protector"],
    headline: "Cooks like it's a love letter.",
    bio: "Chef. Insists dinner is an argument for staying alive. Big on family, small on small talk.",
    compatibility: 87,
    scores: {
      values: 88,
      communication: 85,
      lifestyle: 84,
      chemistry: 91,
      futureGoals: 86,
      effort: 94,
    },
    prompts: [
      { q: "Thing I overthink…", a: "What to cook the first time someone stays over." },
      { q: "I'm most me when…", a: "The kitchen is loud and the people are quiet." },
    ],
    interests: ["Mezcal", "Markets", "Flamenco", "Soccer", "Family dinners"],
    greenFlags: ["Generous", "Warm", "Committed"],
    cautions: ["Unusual hours"],
  },
  {
    id: "p9",
    name: "Sana",
    age: 28,
    location: "Berlin, DE",
    city: "Berlin",
    occupation: "Human rights lawyer",
    video: null,
  image:
      "https://images.unsplash.com/photo-1769650795569-e51a6e9580c3?q=85&w=900&sat=-30",
    videoPoster:
      "https://images.unsplash.com/photo-1769650795569-e51a6e9580c3?q=85&w=1200&sat=-30",
    hasVideo: false,
    tags: ["Intellectual", "Protector", "Quiet Storm"],
    headline: "Argues for a living. Listens better than most.",
    bio: "Lawyer. Long-distance runner. Collector of cafés that let you stay all afternoon.",
    compatibility: 85,
    scores: {
      values: 94,
      communication: 88,
      lifestyle: 80,
      chemistry: 83,
      futureGoals: 89,
      effort: 87,
    },
    prompts: [
      { q: "Where I am most myself…", a: "In the middle of a good argument with a good person." },
      { q: "I want more of…", a: "Quiet, on purpose." },
    ],
    interests: ["Human rights", "Running", "Opera", "Cooking"],
    greenFlags: ["Principled", "Thoughtful"],
    cautions: ["Travels for cases"],
  },
  {
    id: "p10",
    name: "Rafael",
    age: 29,
    location: "Barcelona, ES",
    city: "Barcelona",
    occupation: "Dancer & choreographer",
    video: null,
  image:
      "https://images.unsplash.com/photo-1670687811377-8b39b8644d1a?q=85&w=900&sat=-20",
    videoPoster:
      "https://images.unsplash.com/photo-1670687811377-8b39b8644d1a?q=85&w=1200&sat=-20",
    hasVideo: true,
    tags: ["Romantic", "Creative", "Wildcard"],
    headline: "Moves for a living. Stays for the right reasons.",
    bio: "Choreographer. Believes a good relationship is a duet — not a performance.",
    compatibility: 84,
    scores: {
      values: 86,
      communication: 90,
      lifestyle: 82,
      chemistry: 94,
      futureGoals: 78,
      effort: 88,
    },
    prompts: [
      { q: "A hidden talent…", a: "Remembering exactly where we left off." },
      { q: "Love to me is…", a: "Showing up when the music stops." },
    ],
    interests: ["Contemporary dance", "Flamenco", "Yoga", "Writing"],
    greenFlags: ["Expressive", "Tender"],
    cautions: ["Tour schedule"],
  },
  {
    id: "p11",
    name: "Mina",
    age: 30,
    location: "Seoul, KR",
    city: "Seoul",
    occupation: "VC partner",
    video: null,
  image:
      "https://images.pexels.com/photos/13422041/pexels-photo-13422041.jpeg?w=900&sat=-10",
    videoPoster:
      "https://images.pexels.com/photos/13422041/pexels-photo-13422041.jpeg?w=1200&sat=-10",
    hasVideo: false,
    tags: ["Founder", "Aesthete", "Thinker"],
    headline: "Backs founders. Collects ceramics.",
    bio: "VC partner. Believes taste is a moral category. Strict with herself, kind to everyone else.",
    compatibility: 83,
    scores: {
      values: 85,
      communication: 86,
      lifestyle: 90,
      chemistry: 82,
      futureGoals: 88,
      effort: 84,
    },
    prompts: [
      { q: "I trust people who…", a: "Are generous when nobody is watching." },
      { q: "The compliment I remember…", a: "You make rooms quieter." },
    ],
    interests: ["VC", "Ceramics", "Skiing", "Film"],
    greenFlags: ["Sharp", "Kind"],
    cautions: ["Busy quarter ends"],
  },
  {
    id: "p12",
    name: "Daniel",
    age: 34,
    location: "Cape Town, ZA",
    city: "Cape Town",
    occupation: "Wildlife photographer",
    video: null,
  image:
      "https://images.pexels.com/photos/29433729/pexels-photo-29433729.png?w=900&sat=-20",
    videoPoster:
      "https://images.pexels.com/photos/29433729/pexels-photo-29433729.png?w=1200&sat=-20",
    hasVideo: true,
    tags: ["Adventurer", "Nomad", "Protector"],
    headline: "Spent a decade photographing things that disappear.",
    bio: "Wildlife photographer. Quietly romantic. Looking for somewhere — and someone — to come home to.",
    compatibility: 82,
    scores: {
      values: 85,
      communication: 78,
      lifestyle: 76,
      chemistry: 89,
      futureGoals: 80,
      effort: 86,
    },
    prompts: [
      { q: "What I'd bring back from a trip…", a: "A story, and a better version of me." },
      { q: "What I want now…", a: "Somewhere I keep coming back to." },
    ],
    interests: ["Photography", "Conservation", "Hiking"],
    greenFlags: ["Gentle", "Patient"],
    cautions: ["Long expeditions"],
  },
];

export const you = {
  name: "You",
  shortlist: 7,
  round: 2,
  roundName: "Values Round",
  strongestMatch: "Elena",
  surprisePick: "Kai",
  highestEffort: "Marcus",
  progression: [7, 5, 3, 2, 1],
};

export const roundsMeta = [
  {
    id: "r1",
    name: "Values Round",
    subtitle: "What matters most, and why.",
    kind: "values",
    done: true,
    summary: "5 of 7 advanced. The ones who described belief, not just lifestyle.",
  },
  {
    id: "r2",
    name: "Communication Round",
    subtitle: "How you speak, listen, and repair.",
    kind: "communication",
    done: true,
    summary: "3 of 5 advanced. Tone mattered. So did pacing.",
  },
  {
    id: "r3",
    name: "Chemistry Round",
    subtitle: "A 20-second video prompt. No re-takes.",
    kind: "chemistry",
    done: false,
    current: true,
    summary: "In progress.",
  },
  {
    id: "r4",
    name: "Future Goals Round",
    subtitle: "Where you want to be in five years.",
    kind: "future",
    done: false,
    summary: "Upcoming.",
  },
  {
    id: "r5",
    name: "Effort Round",
    subtitle: "Action over words, observed quietly.",
    kind: "effort",
    done: false,
    summary: "Upcoming.",
  },
  {
    id: "r6",
    name: "Finalist Round",
    subtitle: "Two remain. Choose with care.",
    kind: "final",
    done: false,
    summary: "The last threshold.",
  },
];

export const chatMessages = [
  {
    id: "m1",
    from: "them",
    text: "Your answer about slow Sundays — that was the exact kind of thing I was hoping to read.",
    time: "09:41",
  },
  {
    id: "m2",
    from: "me",
    text: "I meant every word of it. I almost deleted it twice.",
    time: "09:43",
  },
  {
    id: "m3",
    from: "them",
    text: "Please don't. Tell me the one about Rilke sometime.",
    time: "09:44",
  },
  {
    id: "m4",
    from: "me",
    text: "Over dinner. There's a quiet place in the West Village I think you'd like.",
    time: "09:46",
  },
];

export const prices = [
  {
    id: "free",
    name: "Intro",
    price: "$0",
    period: "free",
    tagline: "Begin the journey.",
    features: [
      "Up to 7 shortlist slots",
      "Two active rounds",
      "Basic compatibility view",
      "Standard match pool",
    ],
    cta: "Continue free",
  },
  {
    id: "plus",
    name: "Plus",
    price: "$19",
    period: "/ month",
    tagline: "For serious intention.",
    features: [
      "Unlimited rounds",
      "Full compatibility analytics",
      "Video prompts in every round",
      "Priority match pool",
      "Curated AI recommendation",
      "Undo one round per month",
    ],
    featured: true,
    cta: "Upgrade to Plus",
  },
  {
    id: "private",
    name: "Private Table",
    price: "$49",
    period: "/ month",
    tagline: "Matchmaking, curated.",
    features: [
      "Everything in Plus",
      "Hand-curated shortlist",
      "Private profile mode",
      "Concierge date planning",
      "Premium visibility",
    ],
    cta: "Apply for invite",
  },
];

export const prefsCriteria = [
  { id: "values", label: "Values alignment", weight: 90, must: true },
  { id: "communication", label: "Communication style", weight: 85, must: true },
  { id: "lifestyle", label: "Lifestyle fit", weight: 70, must: false },
  { id: "future", label: "Future goals", weight: 88, must: true },
  { id: "family", label: "Family perspective", weight: 65, must: false },
  { id: "faith", label: "Spirituality", weight: 40, must: false },
  { id: "adventure", label: "Adventure appetite", weight: 60, must: false },
  { id: "effort", label: "Consistent effort", weight: 92, must: true },
];

export const testimonials = [
  {
    name: "Leah, 29",
    quote:
      "I stopped swiping for weeks. Bora Moyo felt like I was actually deciding something, not just scrolling.",
  },
  {
    name: "Andre, 32",
    quote:
      "The round structure made me think about what I actually wanted. The person I'm with now was my round-three choice.",
  },
  {
    name: "Priya, 27",
    quote:
      "It feels like a private club you earn your way into — not a feed.",
  },
];
